import React from 'react';
import './AccessibilityBar.css';

function getCurrentFontSize() {
  return localStorage.getItem('a11y_font') || 'normal';
}

/**
 * Aplica tamanho de fonte via classe CSS no <html>.
 * Usa `zoom` nos containers de UI (sidebar, header, etc.) para escalar
 * todos os elementos incluindo os com font-size em px hardcoded.
 * O mapa Leaflet (.mapview-wrapper) é excluído para não quebrar as coords.
 */
function applyFontSize(size) {
  document.documentElement.classList.remove('font-small', 'font-large');
  if (size !== 'normal') {
    document.documentElement.classList.add(`font-${size}`);
  }
  localStorage.setItem('a11y_font', size);
}

function AccessibilityBar({ contrast, onContrastToggle }) {
  const [fontSize, setFontSize] = React.useState(getCurrentFontSize);

  function handleFontSize(size) {
    applyFontSize(size);
    setFontSize(size);
  }

  // Restaura classe salva no mount
  React.useEffect(() => {
    const saved = getCurrentFontSize();
    setFontSize(saved);
    applyFontSize(saved);
  }, []);

  return (
    <div className="a11y-bar" role="navigation" aria-label="Barra de acessibilidade">
      {/* Skip link — visível apenas no foco por teclado */}
      <a href="#main-content" className="a11y-skip">
        Ir para o conteúdo principal
      </a>

      <div className="a11y-bar-right">
        <span className="a11y-bar-label" aria-hidden="true">Acessibilidade:</span>

        <div className="a11y-bar-divider" aria-hidden="true" />

        <button
          className={`a11y-btn${contrast ? ' a11y-btn--active' : ''}`}
          onClick={onContrastToggle}
          aria-pressed={contrast}
          title={contrast ? 'Desativar alto contraste' : 'Ativar alto contraste'}
        >
          Alto Contraste
        </button>

        <div className="a11y-bar-divider" aria-hidden="true" />

        <div className="a11y-font-controls" role="group" aria-label="Tamanho da fonte">
          <button
            className={`a11y-btn a11y-font-btn${fontSize === 'small' ? ' a11y-btn--active' : ''}`}
            onClick={() => handleFontSize('small')}
            aria-label="Diminuir fonte"
            aria-pressed={fontSize === 'small'}
          >
            A<span aria-hidden="true">-</span>
          </button>
          <button
            className={`a11y-btn a11y-font-btn${fontSize === 'normal' ? ' a11y-btn--active' : ''}`}
            onClick={() => handleFontSize('normal')}
            aria-label="Fonte padrão"
            aria-pressed={fontSize === 'normal'}
          >
            A
          </button>
          <button
            className={`a11y-btn a11y-font-btn${fontSize === 'large' ? ' a11y-btn--active' : ''}`}
            onClick={() => handleFontSize('large')}
            aria-label="Aumentar fonte"
            aria-pressed={fontSize === 'large'}
          >
            A<span aria-hidden="true">+</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AccessibilityBar;
